
const ImageGallery = ({ images, className = "content" }) => {
  return (
    <div className={`${className} horizontal-gallery`}>
      {images.map((image, index) => (
        <img
          key={image.src || image}
          className="gallery"
          src={image.src || image}
          alt=""
          loading="lazy"
          decoding="async"
        />
      ))}
    </div>
  );
};

export default ImageGallery;

